import { render } from "./GlobalSearch.vue?vue&type=template&id=38231814&scoped=true"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"

import "./GlobalSearch.vue?vue&type=style&index=0&id=38231814&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38231814"]])

export default __exports__